import { ClipType, TopAuthorType } from "types";
import "./pie.scss";
import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "hooks/query";
import { actions } from "redux/reducers";
import moment from "moment";
import api from "api";
import useWindowDimensions from "hooks/useWindowDimensions";

function Pie({ authors, filter }: { authors: TopAuthorType[]; filter: "Followers" | "Clips" }) {
    const dispatch = useDispatch();
    const [clips, setClips] = useState<ClipType[]>([]);
    const { height, width } = useWindowDimensions();
    const params = useParams<any>();
    const query = useQuery();
    const legend = authors.map((x) => x.AuthorName);
    const legendOptions = {
        type: "scroll",
        orient: "vertical",
        right: 10,
        top: 20,
        bottom: 20,
        height: height - 400,
        data: legend,
    };
    const legendMobile = {
        type: "scroll",
        orient: "vertical",
        top: 0,
        height: 150,
        data: legend,
    };
    const getData = async () => {
        const projectId = params.projectId;
        const startDate = moment(query.get("datefrom"));
        const endDate = moment(query.get("dateto"));
        const streamIds = query.get("streams")!;
        var clipsToSave = await api.clip.getAll(projectId, startDate, endDate, streamIds);
        setClips(clipsToSave);
    };

    function test() {
        console.log(clips, "##########################");
    }

    const onClick = async (e: any) => {
        console.log(e);
        test();
        console.log(
            "clips:",
            clips.filter((x: ClipType) => x.AuthorName === e.name)
        );
        e.event.stop();
        dispatch(
            actions.clipTray.set({
                loading: true,
                clips: [],
                open: true,
            })
        );
        dispatch(
            actions.clipTray.set({
                loading: false,
                clips: clips.filter((x: ClipType) => x.AuthorName === e.name),
                open: true,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    };
    useEffect(() => {
        getData();
    }, [params.projectId, query]);

    return (
        <div className="pie">
            {clips && (
                <ReactECharts
                    style={{ height: width > height ? height - 300 : height - 500 }}
                    option={{
                        tooltip: {
                            trigger: "item",
                            formatter: "{a} <br/>{b}: {c} ({d}%)",
                        },
                        legend: width > height ? legendOptions : legendMobile,
                        series: [
                            {
                                name: "Top Authors",
                                type: "pie",
                                radius: ["40%", "70%"],
                                avoidLabelOverlap: true,
                                startAngle: 90,
                                label: {
                                    show: false,
                                    position: "center",
                                },
                                emphasis: {
                                    label: {
                                        show: true,
                                        fontSize: "20",
                                        fontWeight: "bold",
                                    },
                                },
                                labelLine: {
                                    show: false,
                                },
                                data: authors.map((item: TopAuthorType, index: number) => {
                                    return {
                                        name: item.AuthorName,
                                        value: filter === "Followers" ? authors[index].FollowerCount : authors[index].ClipCount,
                                    };
                                }),
                            },
                        ],
                    }}
                    onEvents={{
                        click: onClick,
                    }}
                />
            )}
        </div>
    );
}

export default Pie;
